import { Auth } from "../../util/auth";
import { getURL } from "../../util/util";
import { getHeaders } from "../header/common-api";
import { AnalyticsUrlConfigDto } from "./entity/urlconfigdto";
import { getAccessToken } from "../header/common-api";
var sidenavConfigList;

function adjustLeftNav() {
    const header = document.getElementById('mainHeader');
    const leftNav = document.getElementById('mySidebar');

    if (header && leftNav) {
        const headerHeight = header.getBoundingClientRect().height;

        leftNav.style.paddingTop = `${headerHeight}px`;
        leftNav.style.height = `calc(100% - ${headerHeight}px)`;

        const content = document.querySelector('#subapp-container');
        if (content) {
            content.style.marginTop = `${headerHeight + 10}px`;
        }
    }
}


document.addEventListener("DOMContentLoaded", adjustLeftNav);

window.addEventListener("resize", adjustLeftNav);

window.addEventListener("load", adjustLeftNav);

/**
 * @description toggleGroupedItems method is used to open/close accordian and
 *  It is called on click of any grouped sidenav item.
 *
 * @author Arupananda P
 * @since June 26, 2020
 * @param {string} elemId
 */
function toggleGroupedItems(elemId) {
    sidenavConfigList
        .filter((config) => config.grouped)
        .forEach((config) => {
            var domElement = document.getElementById(config.id + "dropdown");
            if (elemId === config.id) {
                let accordionOpen = domElement.style.display === "block";
                setTimeout(() => {
                    domElement.style.display = accordionOpen ? "none" : "block";
                    document
                        .getElementById(config.id + "dropdown")
                        .classList.add("item-top-animation");
                    document
                        .getElementById(elemId + "groupIcon")
                        .classList.remove(
                            accordionOpen ? "fa-angle-down" : "fa-angle-right"
                        );
                    document
                        .getElementById(elemId + "groupIcon")
                        .classList.add(accordionOpen ? "fa-angle-right" : "fa-angle-down");
                }, 400);
            } else {
                setTimeout(() => {
                    domElement.style.display = "none";
                    document
                        .getElementById(config.id + "dropdown")
                        .classList.remove("item-top-animation");
                    // document.getElementById(config.id + 'dropdown').classList.remove("item-top-animation");
                    document
                        .getElementById(config.id + "groupIcon")
                        .classList.remove("fa-angle-down");
                    document
                        .getElementById(config.id + "groupIcon")
                        .classList.add("fa-angle-right");
                }, 400);
            }
        });
}

/**
 * @description getSidenavConfigById is used to get Sidenav Configuration based on id.
 *
 * @author Arupananda P
 * @since June 26, 2020
 * @param {string} id
 * @returns SidenavConfiguration
 */
function getSidenavConfigById(id) {
    var index, index2;
    for (index = 0; index < sidenavConfigList.length; index++) {
        if (sidenavConfigList[index].id === id) {
            return sidenavConfigList[index];
        } else {
            for (
                index2 = 0; index2 < sidenavConfigList[index].subNavigationBarItems.length; index2++
            ) {
                if (sidenavConfigList[index].subNavigationBarItems[index2].id === id) {
                    return sidenavConfigList[index];
                }
            }
        }
    }
    return null;
}

/**
 * @description sideNavItemClicked will be called when we click any independent sidenav item.
 *
 * @author Arupananda P
 * @since June 26, 2020
 * @param {string} itemId
 * @param {string} subItemId
 */
function sideNavItemClicked(itemId, subItemId) {
    sidenavConfigList.forEach((sidenavConfig) => {
        if (
            sidenavConfig.id === itemId &&
            sidenavConfig.subNavigationBarItems.length > 0
        ) {
            sidenavConfig.subNavigationBarItems.forEach((subNavigationBarItem) => {
                if (subNavigationBarItem.id === subItemId) {
                    document
                        .getElementById(subNavigationBarItem.id)
                        .classList.add("active-sidenav");
                    document
                        .getElementById(sidenavConfig.id)
                        .classList.add("group-active");
                        sideNavClicked(subNavigationBarItem.navigationUrl,true)
                    
                } else {
                    document
                        .getElementById(subNavigationBarItem.id)
                        .classList.remove("active-sidenav");
                }
            });
        } else {
            if (sidenavConfig.id === itemId) {
                sideNavClicked(sidenavConfig.navigationUrl,true)
                document.getElementById(sidenavConfig.id).classList.add("active-sidenav");
            } else {
                document.getElementById(sidenavConfig.id).classList.remove("active-sidenav");
                document
                    .getElementById(sidenavConfig.id)
                    .classList.remove("group-active");
            }
        }
    });
}

/**
 * @description setSidenavClickFunctions is used to set sidenav click events.
 *
 * @author Arupananda P
 * @since June 26, 2020
 */
function setSidenavClickFunctions() {
    var inputs, index;
    inputs = document.getElementsByTagName("a");
    for (index = 0; index < inputs.length; index++) {
        const anchorTagId = inputs[index].id;
        const sidenavConfig = getSidenavConfigById(anchorTagId);
        if (sidenavConfig) {
            inputs[index].onclick = () => {
                if (sidenavConfig.id === anchorTagId) {
                    if (sidenavConfig.subNavigationBarItems.length > 0) {
                        toggleGroupedItems(sidenavConfig.id);
                    } else {
                        sideNavItemClicked(sidenavConfig.id, null);
                    }
                } else {
                    sideNavItemClicked(sidenavConfig.id, anchorTagId);
                }
            };
        }
    }
}

/**
 * @description displaySideNavItems is used to initialise the sidenav based on nomenclature configuration
 *
 * @author Arupananda P
 * @since June 26, 2020
 */
function displaySideNavItems() {
    var itemList = `<ul class="sidenav-item-list">
   
       `;
    if (sidenavConfigList && sidenavConfigList.length > 0) {
        sidenavConfigList.forEach((sidenav) => {
            if (
                sidenav.subNavigationBarItems &&
                sidenav.subNavigationBarItems.length > 0
            ) {
                const sideNavUri = sidenav.navigationUri ? sidenav.navigationUri : '';

                itemList += `<li class="sidebar-item grouped">
                    <a  id="${sidenav.id}" data-at="${sideNavUri ? sideNavUri : ''}"><i class="${sidenav.webAppIcon}"></i>&nbsp;
                        <span class="sidebar-itemname navbar-text p-0">${sidenav.itemName}</span>
                        <span class="right-shift-container">
                            <i id="${sidenav.id}groupIcon" class="grouped-item fa fa-angle-right"></i>
                        </span>
                    </a>
                    <ul id="${sidenav.id}dropdown" class="item-top-animation">`;

                sidenav.subNavigationBarItems.forEach((subNavigationBarItem) => {
                    const subNavUri = subNavigationBarItem.navigationUri ? subNavigationBarItem.navigationUri : '';
                    itemList += `<li class="sidebar-item">
                        <a id="${subNavigationBarItem.id}" data-at="${subNavUri ? subNavUri : ''}">
                            <div class="row">
                            <div class="col-1 p-0">
                                <i class="${subNavigationBarItem.webAppIcon} ${subNavigationBarItem.navigationUri}"></i>
                            </div>
                            <div class="col-10 p-0 sidebar-itemname navbar-sub-item-font">&nbsp;${subNavigationBarItem.itemName}</div>
                            </div>
                        </a>
                    </li>`;
                });
                itemList += `</ul></li>`;
            } else {
                const sideNavUri = sidenav.navigationUri ? sidenav.navigationUri : '';
                itemList += `<li class="sidebar-item">
                    <a id="${sidenav.id}" data-at="${sideNavUri ? sideNavUri : ''}">
                        <i class="${sidenav.webAppIcon} ${sidenav.navigationUri}  navbar-item-font"></i>
                        <span class="sidebar-itemname navbar-text p-0">&nbsp;${sidenav.itemName}</span>
                    </a>
                    </li>`;
            }
        });
    }
    itemList += "</ul>";
    document.getElementById("mainSideNav").innerHTML = itemList;
    setSidenavClickFunctions();
}

export function sideNavClicked(url,clicked){
    if(!clicked && Auth.getNavigateUrl()){
        let windowUrl = window.location.href.split('/#/')[1];
        setTimeout(() => {
            history.pushState(
                Auth.getNavigateUrl(),
                url,
                "/"+Auth.getTenantId()+"/#/" + (windowUrl!="auth-mf/refresh"?windowUrl:Auth.getNavigateUrl())
            );
            window.dispatchEvent(new PopStateEvent('popstate')); // important to notify Angular
          }, 1);
       
    } else if(url === "resultanalysis") {
        analyticsNavigate();
    }else{
    Auth.setNavigateUrl(url)
    history.pushState(
        url,
        url,
        "/"+Auth.getTenantId()+"/#/" + url
    );
}
}

export function analyticsNavigate() {
    getAccessToken().then((response) => {
        var analyticsUrlConfig = new AnalyticsUrlConfigDto(response.token, response.uiUrl);
        if (analyticsUrlConfig) {
            localStorage.setItem('analyticsToken', analyticsUrlConfig['token'].dhianalytics_token);
            window.open(analyticsUrlConfig.uiUrl)
        }
    });
}

/**
 * @description getNomenclatureConfiguration is used to get nomenclature configuration from server.
 *
 * @author Arupananda P
 * @since June 26, 2020
 */
export function getNomenclatureConfiguration(refresh) {

    const user = Auth.getUser();
    const myRequest = new Request(
        getURL(Auth.getAcademicLevel()).url +
        "/navigationbarconfig/get-leftnav-items-for-user?userid=" +
        user.id +
        "&usertype=" +
        user.userType +
        "&rolename=" +
        Auth.getCurrentRole() +
        "&platform=WEB&microfrontendtype=MY_PROFILE&microFrontend=" +
        true, {
        method: "GET",
        headers: getHeaders(),
        mode: "cors",
        cache: "default",
    }
    );
    fetch(myRequest)
        .then((response) => {
            return response.json();
        })
        .then((response) => {
            if (response) {
               let  configData = response;
                sidenavConfigList=configData ? configData.navigationBarItems:null
                displaySideNavItems();
                 
                //without clicking leftnav again page loads
                var sidenavConfig;
                if (sidenavConfigList != null && sidenavConfigList.length) {
                    let microFrontendType = Auth.getMicroFrontendTypeToNavigate();
                    let getDefaultPath = window.sessionStorage.getItem("fromPayment");
                    if(getDefaultPath === null || getDefaultPath !== "redirectFromPayment"){
                    if (microFrontendType) {
                        let count = 0;
                        sidenavConfigList.forEach(navBar => {
                            if (navBar.grouped && navBar.subNavigationBarItems && navBar.subNavigationBarItems.length) {
                                navBar.subNavigationBarItems.forEach(item => {
                                    if (item.microFrontendType != null && item.microFrontendType === microFrontendType && count === 0) {
                                        count = 1;
                                        sidenavConfig = item;
                                    }
                                });
                            } else {
                                if (navBar.microFrontendType != null && navBar.microFrontendType === microFrontendType && count === 0) {
                                    count = 1;
                                    sidenavConfig = navBar;
                                }
                            }
                        });
                        if (!sidenavConfig) {
                            getNavigationUrlFromSideNav();
                        }
                    } else if (!microFrontendType) {
                        getNavigationUrlFromSideNav();
                    }
                    if (sidenavConfig) {
                        sideNavClicked(configData.defaultNavigationUrl,refresh)
                    
                    }
                }
            }
            } else {
                document.getElementById("mainSideNav").innerHTML = "";
            }

            function getNavigationUrlFromSideNav() {
                if (sidenavConfigList[0].grouped && sidenavConfigList[0].subNavigationBarItems != null
                    && sidenavConfigList[0].subNavigationBarItems.length) {
                    sidenavConfig = sidenavConfigList[0].subNavigationBarItems[0];
                } else if (!sidenavConfigList[0].grouped) {
                    sidenavConfig = sidenavConfigList[0];
                }
            }
        });
}




/**
 * @description getSideNavDetails is used to get all required datas on sidenav load.
 *
 * @author Arupananda P
 * @since June 26, 2020
 */
export function getSideNavDetails() {
    getNomenclatureConfiguration(false);
}